const apiUrl = {
    url: "http://service.arivotyre.com"
}

export default apiUrl


// WEBPACK FOOTER //
// ./src/utils/api-url.js